/**
 * Shown when WebGL is unavailable (older/locked-down school devices). The skin IS
 * the printed cover art, so a flat image is a perfectly useful fallback preview.
 */
export function Fallback2D({ src }: { src: string }) {
  return (
    <div className="overlay overlay--center fallback2d">
      <div className="fallback2d__frame">
        <img className="fallback2d__img" src={src} alt="Book cover preview" />
      </div>
      <div className="fallback2d__note">3D preview isn’t supported on this device — showing a flat preview.</div>
    </div>
  )
}
